import React, { useState } from 'react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail
} from 'firebase/auth';
import {
  doc,
  setDoc,
  getDoc,
  getDocs,
  collection
} from 'firebase/firestore';
import { auth, db } from '../lib/firebase';
import '../styles/GetUser.css';
import girlieIMG from '../images/girlie.jpeg';
import broIMG from "../images/bro.jpeg";
import loginIMG from "../images/login.png";
import mamitoIMG from "../images/mamito.jpeg";
import useInView from "../lib/useInView";



const GetAuth = ({ setUser }) => {
  // * State variables to manage form inputs and states
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [address, setAddress] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [formType, setFormType] = useState('login');


  // * Handle Animations with inView Hook
  const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
  const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
  const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
  const [box9Ref, box9InView] = useInView({ threshold: 0.7 });



  // * Handler for login form submission
  const handleLogin = async (event) => {
    // Prevent default form submission behavior
    event.preventDefault();
    // Set loading state to true
    setLoading(true);

    try {
      // Sign in with email and password
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // Get the authenticated user
      const user = userCredential.user;

      // Fetch user data from Firestore
      const userDoc = await getDoc(doc(db, 'greenwtb', user.uid));
      if (userDoc.exists()) {
        // If the user document exists, set the user state with the user's data
        setUser({ uid: user.uid, ...userDoc.data() });
      } else {
        // Log if the user document does not exist
        console.log('No such document!');
      }
    } catch (error) {
      // Set error message if login fails
      setError('Please enter correct info to login to gain access');
    } finally {
      setLoading(false);
    }
  };



  // * Handler for registration form submission
  const handleRegister = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      // Create user with email and password in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Generate a 12-digit unique account number
      const generateUniqueAccountNumber = async () => {
        let accountNumber;
        let isUnique = false;

        while (!isUnique) {
          accountNumber = Math.floor(100000000000 + Math.random() * 900000000000).toString();

          // Check if account number already exists in Firestore
          const usersSnapshot = await getDocs(collection(db, "greenwtb"));
          const existingAccountNumbers = usersSnapshot.docs.map(doc => doc.data().accountNumber);

          if (!existingAccountNumbers.includes(accountNumber)) {
            isUnique = true;
          }
        }

        return accountNumber;
      };

      // Generate a 6-digit verification code
      const generateCode = () => Math.floor(100000 + Math.random() * 900000).toString();

      const accountNumber = await generateUniqueAccountNumber();
      const code = generateCode();

      // Store user data in Firestore
      await setDoc(doc(db, "greenwtb", user.uid), {
        fullName,
        address,
        gender,
        dob,
        email,
        group: "cancelled",
        role: "user",
        accountNumber,
        code,
      });

      // Automatically log in the user by setting the user state
      setUser({ uid: user.uid, fullName, address, gender, dob, email, group: "cancelled", role: "user", accountNumber, code });

    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setError("This email is already registered. Please use a different email or log in.");
      } else {
        setError("Error: Could not complete registration. Please check details and try again.");
      }
    } finally {
      setLoading(false);
    }
  };



  // * Handler for forgot password form submission
  const handleForgotPassword = async (event) => {
    // Prevent the default form submission behavior
    event.preventDefault();
    // Set the loading state to true to indicate that the request is in progress
    setLoading(true);

    try {
      // ! Attempt to send a password reset email to the provided email address using Firebase Auth
      await sendPasswordResetEmail(auth, email);
      // If successful, set a success message in the error state (consider renaming error to message for clarity)
      setError('Password reset email sent! Please check your inbox.');
    } catch (error) {
      // If there is an error, set an error message in the error state to notify the user
      setError('Error: Please check email and try again');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div id="hero-section">
        <div className="hero-section">
          <div className="box">
            <div className="auth-containers">
             
              {formType === 'login' && (
                // * by default show login fields
                <>
                  <h2 className='log'>Login to Gain Access</h2>
                  {/* open the registration fields */}
                  <span
                    onClick={() => setFormType('register')}
                    className='reg point'
                  >
                    Don't have an Account? Register Now
                  </span>

                  <form onSubmit={handleLogin}>
                    {/* enter email address */}
                    <div>
                      <label className='transaction-head'>Email:</label>
                      <input
                        type="email"
                        value={email}
                        className='input-field'
                        placeholder='eg. johndoe@email.com'
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    {/* enter password */}
                    <div>
                      <label className='log pass'>Password:</label>
                      <input
                        type="password"
                        className='input-field'
                        placeholder='********'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                      {/* open forgot password field */}
                      <div
                        className='reg point'
                        onClick={() => setFormType('forgotPassword')}
                      >Forgot Password
                      </div>
                    </div>


                    {/* message to handle errors */}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <button type="submit" className='delete-button' disabled={loading}>
                      {loading ? 'Logging in ...' : 'Login'}
                    </button>
                  </form>
                </>
              )}

              {/* if register tab is open */}
              {formType === 'register' && (
                <>
                  <h2 className='log'>Register an Account</h2>
                  <div
                    className='reg point'
                    onClick={() => setFormType('login')}
                  >
                    Already a User? Login to Continue
                  </div>

                  <form onSubmit={handleRegister}>
                    <div className='form-cover'>
                      {/* enter full name */}
                      <div>
                        <label className='transaction-head'>Full Name:</label>
                        <input
                          type="text"
                          value={fullName}
                          placeholder='eg. John Doe'
                          className='input-field'
                          onChange={(e) => setFullName(e.target.value)}
                          required
                        />
                      </div>

                      {/* enter home address */}
                      <div>
                        <label className='transaction-head'>Address:</label>
                        <input
                          type="text"
                          value={address}
                          className='input-field'
                          placeholder='eg. 123 Expressway, NY'
                          onChange={(e) => setAddress(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className='form-cover'>
                      {/* select your gender */}
                      <div>
                        <label className='transaction-head'>Gender:</label>
                        <select
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                          required>
                          <option value="" disabled hidden>Select a Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>

                      {/* select account type */}
                      <div>
                        <label className='transaction-head'>Date of Birth:</label>
                        <input
                          type="date"
                          value={dob}
                          className='input-field'
                          onChange={(e) => setDob(e.target.value)}
                          required />
                      </div>
                    </div>


                    <div className='form-cover'>
                      {/* enter email address */}
                      <div>
                        <label className='transaction-head'>Email:</label>
                        <input
                          type="email"
                          value={email}
                          className='input-field'
                          placeholder='eg. johndoe@email.com'
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      {/* enter password */}
                      <div>
                        <label className='transaction-head'>Password:</label>
                        <input
                          type="password"
                          value={password}
                          className='input-field'
                          placeholder='********'
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    {/* handle error message */}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <button type="submit"
                      className='delete-button'
                      disabled={loading}>
                      {loading ? 'Registering ...' : 'Register'}
                    </button>
                  </form>
                </>
              )}


              {formType === 'forgotPassword' && (
                // if forgot password is open
                <>
                  <h2 className='log'>Enter Email to Reset Password</h2>
                  {/* open login form */}
                  <span
                    className='reg point'
                    onClick={() => setFormType('login')}>
                    Back to Login
                  </span>
                  <form onSubmit={handleForgotPassword}>
                    <div>
                      {/* enter email to reset password */}
                      <label className='transaction-head'>Email Address:</label>
                      <input
                        type="email"
                        value={email}
                        className='input-field'
                        placeholder='eg. johndoe@email.com'
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    {/* handle error or success message */}
                    {error && <p style={{ color: 'black' }}>{error}</p>}
                    <button
                      type="submit"
                      className='delete-button'
                      disabled={loading}>
                      {loading ? 'Resetting ...' : 'Reset Password'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>

          <div className="box">
          {/* empty */}
          </div>
        </div>
      </div>


      {/* next content here */}
      <div className="main-box-cover">
        <h2 className="text-heading center">
          More needed - <span> More todo.</span>
        </h2>
        <div className="box-text center">
          We offer our clients comprehensive investment solutions that are tailored to each particular client’s needs at a specific period of time.
          For 27 years, we have been providing secure and easy U.S. banking to over 400,000 who live, travel, shop and work in the U.S. We make cross-border banking easy and secure.
        </div>
      </div>

      <div className="last-section">
        <div className="box">
          <img
            ref={boxImgRef}
            src={loginIMG}
            alt="Sky High National Trust Bank"
            className={`box-image animate__animated ${boxImgInView ? "animate__pulse" : ""}`}
          />
        </div>
        <div className="box">
          <div
            ref={box7Ref}
            className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
          >
            <img src={mamitoIMG}
              className="boxed-icon"
              alt="WORKING AND INVESTING IN THE U.S."
            />
            <div className="title-text">
              <h3 className="box-title">
                WORKING AND INVESTING IN THE U.S.
              </h3>
              <div className="box-text">
                Explore endless career and investment opportunities in the U.S. – from building a thriving career to making smart financial moves in one of the world's strongest economies.                            </div>
            </div>
          </div>

          <div
            ref={box8Ref}
            className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
          >
            <img src={broIMG}
              className="boxed-icon"
              alt="RELOCATING AND SCHOOLING IN THE U.S."
            />
            <div className="title-text">
              <h3 className="box-title">
                RELOCATING AND SCHOOLING IN THE U.S.
              </h3>
              <div className="box-text">
                Make your move to the U.S. seamless—discover the best schools, opportunities, and everything you need for a successful transition.
              </div>
            </div>
          </div>

          <div
            ref={box9Ref}
            className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
          >
            <img src={girlieIMG}
              className="boxed-icon"
              alt="INTERNATIONAL BUSINESS WITH FOREIGNERS"
            />
            <div className="title-text">
              <h3 className="box-title">
                INTERNATIONAL BUSINESS WITH FOREIGNERS
              </h3>
              <div className="box-text">
                Seamlessly conduct international transactions, manage foreign investments, and build strong financial partnerships with global banking solutions.                            </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default GetAuth;
